import React, { useState } from "react";
import { motion } from "framer-motion";
import { ChevronLeftIcon, ChevronRightIcon, GiftIcon } from "lucide-react";
export type BonusSlide = {
  title: string;
  subtitle: string;
  image: string;
};
type BonusCarouselProps = {
  bonuses: BonusSlide[];
  href: string;
};
export function BonusCarousel({
  bonuses,
  href
}: BonusCarouselProps) {
  const [activeIndex, setActiveIndex] = useState(0);
  const activeBonus = bonuses[activeIndex];
  function showPrevious() {
    setActiveIndex(current => (current - 1 + bonuses.length) % bonuses.length);
  }
  function showNext() {
    setActiveIndex(current => (current + 1) % bonuses.length);
  }
  return <div className="mt-5" data-id="element-84" data-mp="1x4fdkwvj78n0">
      <div className="relative overflow-hidden rounded-2xl border border-amber-300/35 bg-black/50 shadow-xl shadow-black/20" data-id="element-85" data-mp="1x4yty95j9oyx">
        <a href={href} className="block focus:outline-none focus:ring-4 focus:ring-lime-300/50" data-id="element-86" data-mp="3uw1jww1qdw3z">
          <motion.div key={activeBonus.image} initial={{
          opacity: 0.45,
          x: 28
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.24,
          ease: "easeOut"
        }} drag="x" dragConstraints={{
          left: 0,
          right: 0
        }} dragElastic={0.15} onDragEnd={(_, info) => {
          if (info.offset.x > 60) showPrevious();
          if (info.offset.x < -60) showNext();
        }} data-id="element-87" data-mp="2r6abmtkwjd7">
            <img src={activeBonus.image} alt={activeBonus.title} className="aspect-[4/3] w-full object-cover" data-id="element-88" data-mp="2y9naule7qgr" />
          </motion.div>
        </a>

        <div className="absolute inset-x-0 bottom-0 bg-black/80 px-4 py-3 backdrop-blur-sm" data-id="element-89" data-mp="3p5hmff5pz14c">
          <div className="flex items-start gap-2" data-id="element-90" data-mp="3k6oavs9ztk6t">
            <GiftIcon className="mt-0.5 h-4 w-4 shrink-0 text-amber-300" data-id="element-91" data-mp="2drm8g9qjwyep" />
            <div data-id="element-92" data-mp="2dsxcmanws86c">
              <p className="text-xs font-black uppercase tracking-wide text-amber-300" data-id="element-93" data-mp="2dp9j3bigrlrm">Bonus {activeIndex + 1} di {bonuses.length}</p>
              <h3 className="mt-0.5 text-sm font-black leading-5 text-white" data-id="element-94" data-mp="10su4fool8v8e">{activeBonus.title}</h3>
              <p className="mt-1 text-xs leading-4 text-slate-300" data-id="element-95" data-mp="14uyvqgrkdfrv">{activeBonus.subtitle}</p>
            </div>
          </div>
        </div>

        <button type="button" onClick={showPrevious} className="absolute left-2 top-1/2 flex h-9 w-9 -translate-y-1/2 items-center justify-center rounded-full border border-white/20 bg-black/65 text-white backdrop-blur-sm focus:outline-none focus:ring-2 focus:ring-lime-300" aria-label="Bonus precedente" data-id="element-96" data-mp="quo4hcmcdz66">
          <ChevronLeftIcon className="h-5 w-5" data-id="element-97" data-mp="857pxldto66r" />
        </button>
        <button type="button" onClick={showNext} className="absolute right-2 top-1/2 flex h-9 w-9 -translate-y-1/2 items-center justify-center rounded-full border border-white/20 bg-black/65 text-white backdrop-blur-sm focus:outline-none focus:ring-2 focus:ring-lime-300" aria-label="Bonus successivo" data-id="element-98" data-mp="82ljxq6kxyqn">
          <ChevronRightIcon className="h-5 w-5" data-id="element-99" data-mp="3fppesf2g6dwm" />
        </button>
      </div>

      <div className="mt-3 flex items-center justify-center gap-1.5" role="tablist" aria-label="Seleziona un bonus" data-id="element-100" data-mp="3bnuijozdiqpp">
        {bonuses.map((bonus, index) => <button key={bonus.title} type="button" role="tab" aria-label={`Mostra ${bonus.title}`} aria-selected={activeIndex === index} onClick={() => setActiveIndex(index)} className={`h-2 rounded-full transition-all focus:outline-none focus:ring-2 focus:ring-lime-300 ${activeIndex === index ? "w-6 bg-amber-300" : "w-2 bg-white/30 hover:bg-white/60"}`} data-id="element-101" data-mp="3pkr3xawq3fz7" data-mpi={index} />)}
      </div>
      <p className="mt-2 text-center text-xs text-slate-400" data-id="element-102" data-mp="7bgt7qycendy">Scorri per vedere tutti i bonus inclusi</p>
    </div>;
}